import { graphql, Script } from "gatsby"
import * as React from "react"
import Fallback from "../components/fallback"
import SEOHead from "../components/head"
import Layout from "../components/layout"
import * as sections from "../components/sections"

export default function Homepage(props) {
  const { homepage } = props.data

  return (
    <Layout>
      {process.env.GTAG ? [
      <Script
        src={`https://www.googletagmanager.com/gtm.js?id=${process.env.GTAG}`}
        strategy="off-main-thread"
        forward={[`dataLayer.push`]}
      />,
      <Script id="gtm-init" strategy="off-main-thread">
        {`
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ 'gtm.start': new Date().getTime(), 'event': 'gtm.js' })
        `}
      </Script>
      ] : null }
      {homepage.blocks && homepage.blocks.map((block) => {
        const { id, blocktype, ...componentProps } = block
        //if (blocktype !== 'HomepageFaq') return null;
        const Component = sections[blocktype] || Fallback
        return <Component key={id} {...componentProps} />
      })}
    </Layout>
  )
}

export const Head = (props) => {
  const { homepage } = props.data
  return <SEOHead {...homepage} />
}

export const query = graphql`
  {
    homepage {
      id
      title
      description
      image {
        id
        url
      }
      blocks: content {
        id
        blocktype
        ...HomepageHeroContent
        ...HomepageBannerContent
        ...HomepageStatListContent
        ...HomepageFeatureListContent
        ...HomepageLogoListContent
        ...HomepageCompetitorsListContent
        ...HomepageNetworkContent
        ...HomepageCtaContent
        ...HomepageTestimonialListContent
        ...HomepageFaqContent
      }
    }
  }
`
